// extracted by mini-css-extract-plugin
module.exports = {"toggle":"select_toggle__HCNrW","dropdown":"select_dropdown__2kuKD"};